import { useRoutes } from 'react-router-dom';
import { PATH_EMAIL_RECIPIENTS, PATH_PAGE, PATH_REPORTS, PATH_TENANTS } from './paths';
import ReportGenerator from '../pages/reports/ReportGenerator';
import DashboardHistoricalSwitcher from '../pages/reports/DashboardHistoricalSwitcher';
import CreateTenantForm from '../pages/tenants/CreateTenantForm';
import TenantTable from '../pages/tenants/TenantTable';
import EmailRecipientTable from '../pages/email-recipients/EmailRecipientTable';
import CreateEmailRecipientForm from '../pages/email-recipients/CreateEmailRecipientForm';
import EditTenantForm from '../pages/tenants/EditTenantForm';
import TenantCreationGuide from '../pages/tenants/TenantCreationGuide';
import UserReport from '../pages/reports/UserReport';

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <ReportGenerator />
    },
    {
      path: PATH_PAGE.help,
      element: <TenantCreationGuide />
    },
    {
      path: PATH_REPORTS.general.create,
      element: <ReportGenerator />
    },
    {
      path: PATH_REPORTS.general.history,
      element: <DashboardHistoricalSwitcher />
    },
    {
      path: PATH_REPORTS.general.byClassification(':classification'),
      element: <UserReport />,
    },
    {
      path: PATH_TENANTS.general.create,
      element: <CreateTenantForm />
    },
    {
      path: PATH_TENANTS.general.view,
      element: <TenantTable />
    },
    {
      path: PATH_EMAIL_RECIPIENTS.general.create,
      element: <CreateEmailRecipientForm />
    },
    {
      path: PATH_EMAIL_RECIPIENTS.general.view,
      element: <EmailRecipientTable />
    },
    {
      path: '/tenants/edit/:id',
      element: <EditTenantForm />
    },
  ]);
}
